module.exports = "/images/slide-qs-t-8.jpg";